"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stats;
function stats() {
  var _this = this;

  return {
    total: function total() {
      var url = "/stats/total";

      return _this.request({
        url: url,
        method: "GET"
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/unsplash-js/lib/methods/stats.js
// module id = WdIU
// module chunks = 4